import api from '../../utils/api'
import axios from 'axios'

export const state = {
  feedbacks: [],
  feedbackMeta: {}
}

export const mutations = {
  SET_FEEDBACKS(state, feedbacks) {
    state.feedbacks = feedbacks
  },
  SET_FEEDBACK_META(state, feedbackMeta) {
    state.feedbackMeta = feedbackMeta
  }
}

export const actions = {
  async handleSend(_, body) {
    try {
      return await api.post(`/feedback/send`, body)
    } catch (e) {
      console.error(e)
    }
  },

  async handlePaginatedList({ commit, state }, payload) {
    try {
      let params = {}

      if (payload) {
        params = {
          skip: payload.skip || 0,
          limit: payload.limit || 10,
          startDate: payload.startDate || null,
          endDate: payload.endDate || null,
          email: payload.email || null
        }
      }

      const { data: response } = await api.get(`/feedback`, { params })
      commit('SET_FEEDBACKS', response.items)
      commit('SET_FEEDBACK_META', response.meta)
    } catch (e) {
      console.error(e)
    }
  },

  async handlesSendFispqExtractionErrorEmail(_, body) {
    try {
      return await api.post(`/feedback/fispq-extraction-error-email`, body)
    } catch (e) {
      console.error(e)
    }
  },

  resetFilter({ commit }) {
    commit('SET_FEEDBACKS', []);
    commit('SET_FEEDBACK_META', {});
  },
}

export const getters = {
  feedbacks: (state) => state.feedbacks,
  feedbackMeta: (state) => state.feedbackMeta
}
